import { memo } from 'react';
import { IconArrowsRepeat } from '@optimizely/axiom-icons';
import { NodeProps, Position } from '@xyflow/react';

import { NodeConnectionTypes, NodeTypeCategory } from '../../types/connections';
import { NODE_TYPE } from '../../types/node';
import { defineNode } from '../../utils/node-factory';
import { ForLoopSubflow } from '../components/renderers/ForLoopSubflow/ForLoopSubflow';

/**
 * Configuration for the For Loop node type.
 * Executes nested steps for each item in a collection.
 */
export const forLoopConfig = defineNode({
  description: {
    displayName: 'For Loop',
    name: NODE_TYPE.FOR_LOOP,
    description: 'Execute nested steps for each item in a collection',
    iconInfo: {
      icon: IconArrowsRepeat,
      color: 'fg.warning',
    },
    category: NodeTypeCategory.LOGIC,
    input: {
      type: NodeConnectionTypes.Main,
      filter: {
        allowedNodeTypes: [
          { type: NODE_TYPE.SPECIALIZED, maxConnections: 1 },
          { type: NODE_TYPE.CONDITIONAL, maxConnections: 1 },
        ],
      },
    },
    output: {
      type: NodeConnectionTypes.Main,
      displayName: 'Next Step',
      maxConnections: 1,
      handlerPosition: Position.Right,
    },
    properties: [
      {
        displayName: 'Name',
        name: 'name',
        type: 'string',
        required: true,
        default: '',
        description: 'A descriptive name for this loop step',
      },
      {
        displayName: 'Description',
        name: 'description',
        type: 'string',
        required: false,
        default: '',
        description: 'Optional description of what this loop does',
      },
    ],
    defaults: {
      name: 'For Loop',
      parameters: {
        name: 'For Loop',
        description: 'Execute steps for each item in a collection',
      },
    },
  },

  render: memo(function ForLoopRenderer(props: NodeProps) {
    return <ForLoopSubflow {...props} />;
  }),
});
